shadow$provide[109] = function(require,module,exports) {
module.exports=(React);
};